"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.configureHtmlText = exports.HtmlText = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactJsxParser = _interopRequireDefault(require("react-jsx-parser"));
var _personalization = require("../personalization");
var _jsxRuntime = require("react/jsx-runtime");
const renderError = function (e) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    "data-testid": "renderError",
    children: "Parser Error"
  });
};
const onError = function (e) {
  console.log("JSX Parser Error", e);
};
const Private = function (_ref) {
  let {
    children
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    "data-cs-mask": "",
    "data-testid": "Private",
    children: children
  });
};
const configureHtmlText = function () {
  let components = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return /*#__PURE__*/_react.default.memo(function (_ref2) {
    let {
      children: text = "",
      bindings = {},
      ...props
    } = _ref2;
    const personalizationData = (0, _personalization.usePersonalizedContext)();
    const binds = {
      user: personalizationData,
      ...bindings
    };
    const componentBindings = {
      Private,
      private: Private,
      ...components
    };
    return typeof text === "string" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactJsxParser.default, {
      autoCloseVoidElements: true,
      components: componentBindings,
      jsx: text,
      onError: onError,
      renderError: renderError,
      renderInWrapper: false,
      bindings: binds,
      blacklistedAttrs: false,
      ...props
    }) : text;
  });
};
exports.configureHtmlText = configureHtmlText;
const HtmlText = exports.HtmlText = configureHtmlText({});
var _default = exports.default = HtmlText;